import React, { Fragment, useContext } from 'react'
import { Heading, Paragraph } from '@scentregroup/ui'
import { WhatsOnRange } from '../../../types/whats-on'
import { getTimeRangeSlug } from '../../helpers/time-ranges'
import { FeatureFlagsContext, PromotionPositionContext } from '../../context'
import WhatsOnListItem from './whats-on-list-item'
import WhatsOnMoreList from './whats-on-more-list'
import styles from './index.module.scss'

const MAX_INITIAL_LOAD = 10
export interface WhatsOnListProps {
  ranges: WhatsOnRange[]
  id?: string
  analyticsDisplayId?: string
}

const WhatsOnList = ({
  ranges,
  id,
  analyticsDisplayId,
}: WhatsOnListProps): React.ReactElement => {
  const IS_SEE_MORE = useContext(FeatureFlagsContext)
    .NEXT_PUBLIC_TOGGLE_WHATS_HAPPENING_SEE_MORE
  return (
    <div className={styles.whatsOnListContainer} id={id} aria-live="polite">
      {ranges.map(range => {
        const slug = getTimeRangeSlug(range.name)
        const showLoadMore =
          IS_SEE_MORE && range.items.length > MAX_INITIAL_LOAD
        const items = showLoadMore
          ? range.items.slice(0, MAX_INITIAL_LOAD)
          : range.items
        return (
          <Fragment key={range.name}>
            <Heading
              type="megasmalldivider"
              className={styles.divider}
              id={`${slug}-heading`}
            >
              {range.name}
            </Heading>
            {items.length === 0 ? (
              <div className={styles.emptyGroup}>
                <Paragraph>
                  No content on {range.name.toLowerCase()} please change your
                  search criteria
                </Paragraph>
              </div>
            ) : (
              <ul
                id={`${slug}-list`}
                className={showLoadMore ? styles.listWithLoadMore : styles.list}
              >
                <PromotionPositionContext.Provider
                  value={`${analyticsDisplayId}/${slug}`}
                >
                  {items.map((item, i) => (
                    <WhatsOnListItem key={i} item={item} />
                  ))}
                  {showLoadMore && (
                    <WhatsOnMoreList
                      range={range.name}
                      items={range.items.slice(MAX_INITIAL_LOAD)}
                    />
                  )}
                </PromotionPositionContext.Provider>
              </ul>
            )}
          </Fragment>
        )
      })}
    </div>
  )
}
export default WhatsOnList
